import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./ReadMore.scss";

interface ReadMoreProps {
  fontSize?: number;
  url: string;
  text: string;
}

const ReadMore = ({ fontSize = 20, url, text }: ReadMoreProps) => {
  return (
    <div className="readMore">
      <a href={url} target="_blank" rel="noreferrer">
        <span>{text}</span>
        <OpenInNewIcon
          className="listMobileCardReadMoreIcon"
          sx={{ fontSize }}
        />
      </a>
    </div>
  );
};

export default ReadMore;
